<template>
  <div class="bg-white rounded-2xl shadow p-6">
    <div class="rounded-2xl p-6">
      <h2 class="text-center font-bold mb-4">
        Organizacionais, Pessoas, Físicos e Tecnológicos
      </h2>
      <canvas ref="barChart"></canvas>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import {
  Chart,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'
import { getTypes_ControlByIdEnterprise } from '@/services/graphs/api.types_control.js'

Chart.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const props = defineProps({
  enterpriseId: { type: String, required: true },
})

const barChart = ref(null)
let chartInstance = null

function debounce(fn, delay = 200) {
  let timeout
  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => fn(...args), delay)
  }
}

async function loadChart(id) {
  if (!id) return

  try {
    const data = await getTypes_ControlByIdEnterprise(id)
    const d = Array.isArray(data) ? data[0] : data

    const tiposControle = ['Corretivo', 'Detectivo', 'Preventivo']
    const implemented = [
      d.TypeControlCorrectiveImplemented,
      d.TypeControlDetectiveImplemented,
      d.TypeControlPreventiveImplemented,
    ]
    const partial = [
      d.TypeControlCorrectivePartiallyImplemented,
      d.TypeControlDetectivePartiallyImplemented,
      d.TypeControlPreventivePartiallyImplemented,
    ]
    const notImplemented = [
      d.TypeControlCorrectiveNotImplemented,
      d.TypeControlDetectiveNotImplemented,
      d.TypeControlPreventiveNotImplemented,
    ]

    if (chartInstance) chartInstance.destroy()

    chartInstance = new Chart(barChart.value, {
      type: 'bar',
      data: {
        labels: tiposControle,
        datasets: [
          {
            label: 'Implementados',
            data: implemented,
            backgroundColor: '#22c55e',
          },
          { label: 'Parciais', data: partial, backgroundColor: '#facc15' },
          {
            label: 'Não Implementados',
            data: notImplemented,
            backgroundColor: '#ef4444',
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: { legend: { position: 'top' } },
        scales: {
          x: { stacked: true },
          y: {
            stacked: true,
            beginAtZero: true,
            max: 100,
            title: { display: true, text: 'Percentual (%)' },
          },
        },
      },
    })
  } catch (err) {
    console.error('Erro ao carregar gráfico:', err)
  }
}

const debouncedLoadChart = debounce(loadChart, 250)

watch(
  () => props.enterpriseId,
  (id) => {
    debouncedLoadChart(id)
  },
  { immediate: true }
)

onMounted(() => {
  if (props.enterpriseId) debouncedLoadChart(props.enterpriseId)
})
</script>
